import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, withRouter } from "react-router-dom";
import CpfInput from '../../../inputs/CpfInput';
import server from '../../../server';
import TelephoneInput from '../../../inputs/TelephoneInput';
import EmailInput from '../../../inputs/EmailInput';

class Register extends Component{
    constructor(props) {
      super(props)
    
      this.state = {
         name:"",
         birthDate:"",
         telephone:"",
         cpf:server.homeAppointmentData.user.cpf,
         email:"",
         redirectTo: null
      }
    }

    register = () =>{
        this.state.cpf = server.formatCpf(this.state.cpf);
        server.post("users", this.state, (user)=>{
            if(typeof(user) != typeof({}) || user.id == null) this.props.alert("Houve um problema...", user, "error");

            let appointmentData = {};
            let date = server.homeAppointmentData.date

            appointmentData["dates"] = JSON.stringify([date.getFullYear() + '-' +
            ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
            ('00' + date.getDate()).slice(-2) + ' ' +
            (server.homeAppointmentData.time)])

            appointmentData["fisioterapistId"] = 1;
            appointmentData["clinic"] = true;
            appointmentData["evaluation"] = true;
            appointmentData["price"] = 100;

            appointmentData = {...appointmentData, ...user};
            let that = this;

            server.post("appointments", appointmentData, (data) =>{
                if(typeof(data) == typeof({})){
                    that.setState({redirectTo:"/home"}, () => this.props.alert("Sucesso!", "Sua consulta foi marcada com sucesso!", "success"));
                }else this.props.alert("Houve um problema...", data, "error");
            })
        })
    }
    
    changeState = (e) =>{
        this.setState({[e.target.id]:e.target.value});
    }

    render(){
        if(this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>

        return(
            <div>
                <h3 class="c-client-default mB-0">Faça o seu cadastro</h3>
                <hr/>
                <form id="form-home" class="register-form">
                    <div class="form-input mT-10">
                        <label>Nome</label>
                        <input id="name" onChange={this.changeState} value={this.state.name} type="text" placeholder="Informe seu nome"/>
                    </div>
                    <div class="form-input mT-10">
                        <label>Data de Nascimento</label>
                        <input id="birthDate" onChange={this.changeState} value={this.state.birthDate} type="date" placeholder="Informe sua data de nascimento"/>
                    </div>
                    <div class="form-input mT-10">
                        <label>Telefone</label>
                        <TelephoneInput id="telephone" onChange={this.changeState} value={this.state.telephone} placeholder="Informe o seu telefone"/>
                    </div>
                    <div class="form-input mT-10">
                        <label>CPF</label>
                        <CpfInput id="cpf" onChange={this.changeState} value={this.state.cpf} placeholder="Informe o seu CPF"/>
                    </div>
                    <div class="w-100p mT-10">
                        <label>E-mail</label>
                        <EmailInput style={{}} id="email" onChange={this.changeState} value={this.state.email} placeholder="Informe o seu e-mail"/>
                    </div>
                </form>
                <div class="ta-c peers jc-c">
                    <button onClick={this.register} type="button" class="btn btn-outline-quartenary fsz-md bdr-full  mT-30 pX-30 pY-10 big-button-text">
                        <b>CADASTRE-SE</b>
                    </button>
                </div>
            </div>
        )
    }
}

class StillNotBlues extends Component{
    constructor(props) {
      super(props)
    
      this.state = {
         redirectTo: null
      }
    }
    
    render(){
        if(this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>

        return(
            <div>
                <h3 class="c-client-default mB-0">Ainda não é Blues</h3>
                <hr/>
                <p class="mT-0">Faça o cadastro e começe a usar a Blues, é simples e rápido. Leva menos de 1
                    minuto!</p>
                <div class="ta-c peers jc-c">
                    <button onClick={() => this.setState({redirectTo:"/home/checkout/register"})} 
                            type="button" 
                            class="btn btn-outline-quartenary fsz-md bdr-full  mT-30 pX-30 pY-10 big-button-text">
                        Clique aqui e <b>CADASTRE-SE</b>
                    </button>
                </div>
            </div>
        )
    }
}

class FoundAccount extends Component{
    constructor(props) {
      super(props)
    
      this.state = {
         password:"",
         redirectTo: null
      }
    }

    createAppointment = () =>{
        let appointmentData = {};
        let date = server.homeAppointmentData.date

        appointmentData["dates"] = JSON.stringify([date.getFullYear() + '-' +
        ('00' + (date.getMonth() + 1)).slice(-2) + '-' +
        ('00' + date.getDate()).slice(-2) + ' ' +
        (server.homeAppointmentData.time)])

        appointmentData["fisioterapistId"] = 1;
        appointmentData["clinic"] = true;
        appointmentData["evaluation"] = true;
        appointmentData["price"] = 100;

        appointmentData = {...appointmentData, ...server.homeAppointmentData.user};

        let that = this;

        server.post("appointments", appointmentData, (data) =>{
            if(typeof(data) == typeof({})){
                that.setState({redirectTo:"/home"}, () => this.props.alert("Sucesso!", "Sua consulta foi marcada com sucesso!", "success"));
            }else this.props.alert("Houve um problema...", data, "error");
        })
    }

    login = () =>{
        let data = {password:this.state.password, cpf:server.homeAppointmentData.user.cpf};
        server.post("login", data, (data) =>{
            if(typeof(data) == typeof({})) this.createAppointment();
            else this.props.alert("Houve um problema...", data, "error");
        })
    }
    
    render(){
        if(this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>

        return(
            <div>
                <h3 class="c-client-default mB-0">Encontramos o seu cadastro</h3>
                <hr/>
                <p class="mT-0"><b>{server.homeAppointmentData.user.name}</b>, encontramos o seu cadastro em nosso sistema. Por favor insira sua senha 
                para confirmar o agendamento da consulta.</p>

                <div>
                    <h5 class="mB-0"><b>A sua consulta será em:</b></h5>
                    {server.fullDateString(server.homeAppointmentData.date)} às {server.homeAppointmentData.time}
                </div>
                <br/><br/>

                <form id="form-home" class="search-bar-form peers input-document">
                    <div class="mB-10 document-form">
                        <input id="password" value={this.state.password} type="password" onChange={(e) => this.setState({password:e.target.value})}/>
                        <button onClick={this.login} type="button" class="btn btn-quartenary mL-5 login-btn d-n@sm-">
                            
                            <i class="material-icons fsz-md">
                                arrow_forward
                            </i>
                        </button>
                    </div>
                    <div class="peers jc-c  d-n@sm+">
                        <button onClick={this.login} type="button" class="btn btn-quartenary mL-5 login-btn">
                            <i class="material-icons fsz-md">
                                arrow_forward
                            </i>
                        </button>
                    </div>

                </form>
            </div>
        )
    }
}

class WhoAreYou extends Component{
    constructor(props) {
      super(props)
    
      this.state = {
         cpf:"",
         redirectTo:null
      }
    }
    

    checkCpf = () =>{
        let cpf = server.formatCpf(this.state.cpf);
        server.get("users/cpf/" + cpf, (data) =>{
            if(typeof(data) == typeof({})){
                server.homeAppointmentData.user = data;
                this.setState({redirectTo:"/home/checkout/confirm"});
            }
            else{
                server.homeAppointmentData.user = {cpf:cpf};
                this.setState({redirectTo:"/home/checkout/notfound"});
            }
        })
    }

    render(){
        if(this.state.redirectTo) return <Redirect to={this.state.redirectTo}/>
        return(
            <div>
                <h3 class="c-client-default mB-0">Quem é você?</h3>
                <hr/>
                <p class="mT-0">Para agendar uma consulta a <b>Blues</b> precisa saber quem é você. Por favor
                    informe o número do seu CPF para verificarmos. Conosco seus dados ficam seguros, não se
                    preocupe!</p>
                <form id="form-home" class="search-bar-form peers input-document">
                    <div class="mB-10 document-form">
                        <CpfInput id="cpf" value={this.state.cpf} onChange={(e) => this.setState({cpf:e.target.value})}/>
                        <button onClick={this.checkCpf} type="button" class="btn btn-quartenary mL-5 login-btn d-n@sm-">
                            
                            <i class="material-icons fsz-md">
                                arrow_forward
                            </i>
                        </button>
                    </div>
                    <div class="peers jc-c  d-n@sm+">
                        <button onClick={this.checkCpf} type="button" class="btn btn-quartenary mL-5 login-btn">
                            <i class="material-icons fsz-md">
                                arrow_forward
                            </i>
                        </button>
                    </div>

                </form>
            </div>
        )
    }
}

export default class Checkout extends Component{
    constructor(props) {
      super(props)
    
      this.state = {
         cpf: null,
      }
    }

    changeState = (e) =>{
        this.setState({[e.target.id]: e.target.value});
    }

    redirectTo = (redirect) =>{
        this.props.history.push("/home/checkout/" + redirect);
    }

    render(){
        return(
            <div>
                <section id="top-checkout">
                    <div class="peers w-100p h-100p jc-c ai-c">
                        <div class="blues-content">
                            <div class="checkout-results-header">
                                <h5 class="mB-0 pB-0 c-client-default-secondary">Agendamento de consulta</h5>
                                <h3 class="c-client-default pT-0 mT-0 mB-0"><b>{server.fullDateString(server.homeAppointmentData.date)}</b></h3>
                                <h3 class="c-client-default pT-0 mT-0">{server.homeAppointmentData.time}</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="checkout-content">
                    <div class="peers w-100p h-100p jc-sb">
                        <div class="blues-content">
                            <div class="checkout-details">
                                <div class="checkout-info">
                                    <div class="checkout-image">
                                        <img src="/assets/images/livia.jpeg"/>
                                    </div>
                                    <div class="checkout-block-content p-20">
                                        <span><b>Dra. Lívia Rodrigues - Fisioterapeuta</b></span>
                                        <h5 class="c-client-default m-0 w-100p clinic-title"><b>Blues Copacabana</b></h5>
                                        <div class="checkout-block-content__info">
                                            <div>
                                                <p>
                                                    Rua Constante Ramos, 44 - Cobertura 5<br/>
                                                    Bairro: Copacabana - Rio de Janeiro - RJ
                                                </p>
                                                <div class="fsz-xs">Especialidade</div>
                                                <h3 class="c-client-default mT-0"><b>Ortopedia</b></h3>
                                                <h3 class="c-client-default mT-0"><b>Traumatologia</b></h3>
                                                <h3 class="c-client-default mT-0"><b>Geriatria</b></h3>
                                                <div class="mT-20">
                                                    <div class="fsz-xs">Valor da sessão</div>
                                                    <div class="checkout-result-price">R$ 160,00 </div>
                                                </div>
                                                <div class="mT-30">
                                                    <Link to="/home" type="button" class="btn btn-quartenary fsz-md bdr-full  pX-30 pY-10">
                                                        <b>Voltar</b>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="checkout-form">
                                    <Router>
                                        <div>
                                            <Route path="/home/checkout" exact component={() => <WhoAreYou/>}/>
                                            <Route path="/home/checkout/confirm" component={() => <FoundAccount alert={this.props.alert}/>}/>
                                            <Route path="/home/checkout/notfound" component={() => <StillNotBlues/>}/>
                                            <Route path="/home/checkout/register" component={() => <Register alert={this.props.alert}/>}/>
                                        </div>
                                    </Router>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/pages/Checkout.js